import { inject } from "@angular/core";
import { catchError, map, Observable, of } from "rxjs";
import { AuthService } from "./shared/auth.service";
import { RedirectCommand, Router } from "@angular/router";
import { AppStore } from "./store/app.store";
import { UserService } from "./shared/user.service";

export function isAuthenticatedGuard(): Observable<boolean | RedirectCommand>  {
    const authService = inject(AuthService);
    const router = inject(Router);
    const loginPath = router.parseUrl('/login');
    const redirectCommand = new RedirectCommand(loginPath);

    return authService.isAuthenticated().pipe(
        map((isAuthenticated) => {
            if (!isAuthenticated) {
                return redirectCommand;
            }

            return true;
        }),
        catchError(() => {
            return of(redirectCommand);
        })
    );
}

export function isAdminGuard(): Observable<boolean | RedirectCommand> {
    const appStore = inject(AppStore);
    const userService = inject(UserService);
    const router = inject(Router);
    const nominations = router.parseUrl('/nominations');
    const redirectCommand = new RedirectCommand(nominations);

    if (appStore.isStoreLoaded()) {
        return appStore.user().permissions.approveOrReject || appStore.user().permissions.viewOnly
            ? of(true)
            : of(redirectCommand);
    }

    return userService.getUserPermissions().pipe(map(result => {
        return !result
            ? redirectCommand
            : result.approveOrReject || result.viewOnly
                ? true
                : redirectCommand;
    }));
}
